<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">

    <div class="section-header" *ngFor="let Content of projectsContent;">
        <!-- <div class="section-badge">{{Content.subTitle}}</div> -->
        <h1 class="section-title">{{Content.title}}</h1>
        <!-- <p class="section-description">{{Content.paragraph}}</p> -->
    </div>

    <h1 class="blog-title">{{Content.title}}</h1>
    <!-- <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul> -->
</div>
<!-- End Page Title Area -->

<!-- Start Blog Area -->
<section class="blog-area ptb-100">
    <div class="container">
        <div class="row">
            <div style="display:none">

            </div>
            <!-- <div class="col-lg-12 mb-4 text-center">

                <select class="form-select w-auto d-inline-block" (change)="onCategoryChange($event)">
                    <option value="">All Categories</option>
                    <option *ngFor="let cat of categories" [value]="cat.id">
                        {{cat.category_name}}
                    </option>
                </select>

            </div> -->

            <!-- <div class="category-filter-wrapper">

                <div class="filter-box">

                    <label class="filter-label">
                        <i class='bx bx-category'></i>
                        Filter By Category
                    </label>

                    <select class="custom-select" (change)="onCategoryChange($event)">

                        <option value="">
                            All Categories
                        </option>

                        <option *ngFor="let cat of categories" [value]="cat.id">

                            {{cat.category_name}}

                        </option>

                    </select>

                </div>

            </div> -->

            <!-- BLOG CATEGORY ROW -->

            <!-- BLOG CATEGORY ROW -->
            <div class="blog-categories-row">

                <!-- ALL CATEGORY -->
                <button class="blog-category-btn" [class.active]="selectedCategory === ''"
                    (click)="onCategorySelect('')">

                    All Blogs

                </button>

                <!-- CATEGORY LIST -->
                <button class="blog-category-btn" *ngFor="let cat of categories"
                    [class.active]="selectedCategory == cat.id" (click)="onCategorySelect(cat.id)">

                    {{ cat.category_name }}

                </button>

            </div>

          <div class="blog-card col-lg-4 col-md-6"
     *ngFor="let Content of singleBlogPost">

    <div class="premium-blog-card">

        <!-- IMAGE -->
        <div class="premium-image-wrapper">

            <a routerLink="/{{Content.detailsLink}}">

                <img [src]="Content.img"
                     alt="image">

            </a>

            <!-- OVERLAY -->
            <div class="premium-overlay"></div>

            <!-- CATEGORY -->
            <div class="premium-category">

                <i class='bx bx-purchase-tag'></i>

                {{Content.tag}}

            </div>

            <!-- FLOATING BUTTON -->
            <a routerLink="/{{Content.detailsLink}}"
               class="floating-read-btn">

                <i class='bx bx-right-arrow-alt'></i>

            </a>

        </div>

        <!-- CONTENT -->
        <div class="premium-blog-content">

            <!-- META -->
            <div class="premium-meta">

                <span>
                    <i class='bx bx-calendar'></i>
                    Latest Blog
                </span>

                <span>
                    <i class='bx bx-time-five'></i>
                    5 Min Read
                </span>

            </div>

            <!-- TITLE -->
            <h3>

                <a routerLink="/{{Content.detailsLink}}">

                    {{Content.title}}

                </a>

            </h3>

            <!-- DESC -->
            <p>

                {{Content.paragraph}}

            </p>

            <!-- FOOTER -->
            <div class="premium-footer">

                <a routerLink="/{{Content.detailsLink}}"
                   class="premium-link-btn">

                    Read Full Article

                    <i class='bx bx-right-arrow-alt'></i>

                </a>

            </div>

        </div>

    </div>

</div>


            <div class="col-lg-12 text-center mt-4">

                <button class="btn btn-outline-primary me-2" (click)="prevPage()" [disabled]="currentPage === 1">
                    Previous
                </button>

                <span class="mx-3">
                    Page {{currentPage}} of {{totalPages}}
                </span>

                <button class="btn btn-outline-primary ms-2" (click)="nextPage()"
                    [disabled]="currentPage === totalPages">
                    Next
                </button>

            </div>
        </div>
    </div>
</section>
<div class='bg-dark p-1'>
</div>
<!-- End Blog Area -->